import { memo } from "react";
import { LoadingView } from "./LoadingView";
import isEqual from "lodash/isEqual";

export const LoadingViewSmall = memo((props) => {
    const { contentContainerStyle, subline = null, ...rest } = props;

    return (
        <LoadingView 
            hideTitle={true} 
            subline={subline} 
            spinnerSize={25}
            innerPadding={8} 
            contentContainerStyle={{paddingVertical: 25, ...contentContainerStyle}} 
            {...rest} 
        />
    );
}, isEqual);